import {
  OnInit,
  Input,
  Output,
  EventEmitter,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import {
  DocumentoDetalle,
  RevisionDocumento,
  FuncionDocumento
} from './../../models/documento.model';
import { Const } from '@app/shared/util/constants';
@Component({
  selector: 'iw-button-download-review',
  templateUrl: './button-download-review.component.html',
  styleUrls: ['./button-download-review.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonDownloadReviewComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // activa o inactiva el boton de descargar
  activeDownload = true;
  // activa o inactiva el boton de descargar
  activeReview = true;
  // contiene el detalle del documento frente a la tarea actual y su historial y revision
  documentsDetail: DocumentoDetalle;
  // Revisiones del documento
  reviewDocuments: Array<RevisionDocumento> = [];
  // Funciones del documento
  functions: Array<FuncionDocumento> = [];
  // Muestra o oculta el boton de revision aprobada
  reviewApprove = false;
  // Muestra o oculta el boton de revision desaprobada
  reviewDisapprove = false;
  // Activa el boton de revisiones inicial
  reviewEmpty = true;
  // Version del documento
  versionDoc = 0;
  // Define si el documento contiene la funcion de subir
  upload = false;
  // Define si el documento contiene la funcion de generar
  generate = false;
  // Define si el documento contiene la funcion de aprobar o firmar
  approveSign = false;
  // Define si muestra el boton de caratula
  caratula = false;
  // Ejecuta el spiner del botón generar documento
  isLoadingGenerate = false;

  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.isLoadingGenerate = this.rowData.select;
    if (this.rowData.expediente) {
      this.caratula = true;
    }
    this.documentsDetail = this.value[0];
    if (this.documentsDetail) {
      if (this.documentsDetail.historial.length > 0) {
        this.versionDoc = this.documentsDetail.historial.length;
        this.activeDownload = false;
        this.documentsDetail.historial.forEach(historyDocument => {
          if (historyDocument.revision.length > 0) {
            if (historyDocument.version === this.versionDoc) {
              this.reviewEmpty = false;
            }
            historyDocument.revision.forEach(review => {
              review.historial_id = historyDocument.id;
              review.version = historyDocument.version;
              this.reviewDocuments.push(review);
            });
            this.activeReview = false;
          } else {
            if (historyDocument.version === this.versionDoc) {
              this.reviewEmpty = true;
            }
          }
        });
      } else {
        if (this.documentsDetail.documento_cita) {
          this.activeDownload = false;
        }
      }
    }
    this.validReview();
    this.functions = this.rowData.funciones;
    this.loadFunction();
  }

  /**
   * Emite el evento retornando el id del documento
   *
   * @memberof ButtonDownloadReviewComponent
   */
  onDownload() {
    if (this.documentsDetail.historial) {
      const data = {
        'accion': 'download',
        'data': this.documentsDetail
      };
      this.save.emit(data);
    } else {
      const error = {
        'accion': 'error',
        'menssage': 'Aun no se a subido un archivo para este documento'
      };
      this.save.emit(error);
    }
  }
  /**
   * Emite el evento retornando las revisones del documento seleccionado
   *
   * @memberof ButtonDownloadReviewComponent
   */
  onReview() {
    if (this.reviewDocuments.length > 0) {
      const data = {
        'accion': 'review',
        'data': this.reviewDocuments
      };
      this.save.emit(data);
    } else {
      const error = {
        'accion': 'error',
        'message': 'El documento no contiene revisiones'
      };
      this.save.emit(error);
    }
  }
  /**
   * Valida las revisiones y activa los botones correspondientes a la ultima revision
   *
   * @memberof ButtonDownloadReviewComponent
   */
  validReview() {
    if (!this.activeReview) {
      if (!this.reviewEmpty) {
        let idReview = 0;
        this.reviewDocuments.forEach(review => {
          if (review.id_revision > idReview) {
            idReview = review.id_revision;
          }
        });
        this.reviewDocuments.forEach(review => {
          if (review.id_revision === idReview) {
            if (review.revision) {
              this.reviewApprove = true;
              this.reviewDisapprove = false;
            } else {
              this.reviewDisapprove = true;
              this.reviewApprove = false;
            }
            this.activeReview = false;
          }
        });
      } else {
        this.activeReview = true;
        this.reviewDisapprove = false;
        this.reviewApprove = false;
      }
    } else {
      this.activeReview = true;
      this.reviewDisapprove = false;
      this.reviewApprove = false;
      this.reviewEmpty = false;
    }
  }

  /**
   * Emite el evento click de generar el documento
   *
   * @memberof ButtonDownloadReviewComponent
   */
  onGenerate() {
    const data = {
      'accion': 'generate',
      'data': this.rowData
    };
    this.save.emit(data);
  }

  /**
   * Carga los botones dependiendo de las funciones del documento
   *
   * @memberof ButtonDownloadReviewComponent
   */
  loadFunction() {
    this.functions.forEach(funtion => {
      if (funtion.funcion === Const.DOCUMENTS_FUNCTIONS.generate) {
        this.generate = true;
      }
      if (funtion.funcion === Const.DOCUMENTS_FUNCTIONS.approve || funtion.funcion === Const.DOCUMENTS_FUNCTIONS.sign) {
        this.approveSign = true;
      }
    });
    if (
      !this.approveSign &&
      this.documentsDetail &&
      this.documentsDetail.historial &&
      this.documentsDetail.historial.length
    ) {
      for (const history of this.documentsDetail.historial) {
        if (history.revision.length) {
          this.approveSign = true;
          break;
        }
      }
    }
  }

  /**
   * Emite el evento click de mostrar caratula
   *
   * @memberof ButtonDownloadReviewComponent
   */
  onCaratula() {
    const data = {
      'accion': 'caratula',
      'data': this.rowData
    };
    this.save.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/button-download-review/button-download-review.component.ts